import formatNumber from 'format-number';

const formatPrice = formatNumber({integerSeparator: ' ', decimal: ',', truncate: 2});

export default formatPrice;